<template>
  <div class="timer" :class="{ 'visible': toggleTimer, 'invisible': !toggleTimer }">
    <div v-if="timerInput" class="mt-1 mr-2">{{ timerInput.display }}</div>
    <svg v-if="toggleTimer" class="w-5 h-5 text-pink-200" :class="{ 'color-pulse': toggleTimer }">
      <use xlink:href="#recording-filled"/>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    toggleTimer: {
      type: [String, Boolean],
      required: true
    }
  },
  data () {
    return {
      // This var will be synchronised with whatever var you put in v-model on parent
      // component (e.g. "newActivityTitle")
      timerInput: {
        seconds: 0,
        display: '00:00:00'
      },
      //
      timerInterval: null,
      timerPaused: false,
      timerStatus: false,
      //
      timerTmp: ''
    }
  },
  mounted () {
    // this.$l.info('Timer', 'mounted\nthis.toggleTimer =', this.toggleTimer)
  },
  methods: {
    timerDisplayFormat (currTime) {
      let hours = Math.floor(currTime / 3600)
      let minutes = Math.floor(currTime / 60 % 60)
      let seconds = Math.floor(currTime % 60)

      hours = hours < 10 ? ('0' + hours) : hours
      minutes = minutes < 10 ? ('0' + minutes) : minutes
      seconds = seconds < 10 ? ('0' + seconds) : seconds

      return hours + ':' + minutes + ':' + seconds
    },
    startTimer () {
      this.timerPaused = false
      this.timerStatus = true

      this.timerInterval = setInterval(() => {
        if (!this.timerPaused) {
          this.timerInput.display = this.timerDisplayFormat(++this.timerInput.seconds)
        }
      }, 1000)
    },
    stopTimer () {
      clearInterval(this.timerInterval)
      this.$emit('timerStopped', this.timerInput)
    },
    resetTimer () {
      this.stopTimer()
      this.timerInput.seconds = 0 // ATTENTION! Maybe we need this value later to save it to the DB!!!
      this.timerInput.display = '00:00:00'
      this.timerPaused = true
      // Hide timer
      this.timerStatus = false
    }
  },
  watch: {
    toggleTimer: function (newVal) {
      // this.$l.info('Timer', 'watch toggleTimer\nnewVal =', newVal)
      // console.log('Timer', 'watch toggleTimer\nnewVal =', newVal)

      if (newVal === 'recording' || newVal === 'resume' || newVal === true) {
        this.startTimer()
      }
      else if (newVal === 'paused' || newVal === false) {
        this.stopTimer()
      }
    }
  }

}
</script>

<style lang="postcss" scoped>
.timer {
  @apply absolute -top-9 h-7 px-2 py-3 right-0;
  @apply flex flex-row items-center justify-around;
  @apply rounded-md bg-pink-800 bg-opacity-90;
  @apply font-bold text-lg text-pink-200;
  @apply z-20;
}

/* .timer {
  width: 128px;
  left: 50%;
  margin-left: -64px;
}

.timer-border:before {
  content: '';
  position: absolute;
  left: -0.25rem;
  right: -0.25rem;
  top: -0.25rem;
  bottom: 0;
  z-index: -1;
  background: transparent!important;
  @apply border-green-600 border-l-4 border-t-4 border-r-4 rounded-t-md;
}
 */
</style>
